export default __webpack_public_path__ + "static/media/Helm of the Black Warden.37daf9ee.jpg";